import { useState, useEffect } from 'react';
import { FiltersHelper } from '../../common/FiltersHelper';
import { FilterState } from './types';
import StateHelper from '../../utils/StateHelper';
import './LookupFiltersPanel.css';

interface LookupFiltersPanelProps {
  filters: FilterState;
  setFilters: (filters: FilterState) => void;
}

const LookupFiltersPanel = ({
  filters,
  setFilters
}: LookupFiltersPanelProps) => {
  // Using refs as null since these are controlled by React state instead of FiltersHelper state
  const nullRef: any = null;
  
  // Track demand sources state to trigger re-renders
  const [demandSources, setDemandSources] = useState(() => StateHelper.getDemandSourcesState() || []);
  
  // Poll for demand sources updates
  useEffect(() => {
    const pollForDemandSources = () => {
      const currentDemandSources = StateHelper.getDemandSourcesState() || [];
      // Use a more robust comparison - check if the data has actually changed
      if (JSON.stringify(currentDemandSources) !== JSON.stringify(demandSources)) {
        setDemandSources(currentDemandSources);
      }
    };
    
    // Check every 500ms for demand sources updates (reduced frequency for better performance)
    const interval = setInterval(pollForDemandSources, 500);
    
    // Also check immediately
    pollForDemandSources();
    
    return () => clearInterval(interval);
  }, [demandSources]);

  return (
    <div className="filters-container">
      {/* Custom responsive layout without Bootstrap grid constraints */}
      <div className="filters-wrapper">
        <div className="filter-item filter-item-regular">
          {FiltersHelper.getCampaignStatsCard(filters, setFilters, nullRef)}
        </div>
        <div className="filter-item filter-item-regular">
          {FiltersHelper.getCampaignHealthCard(filters, setFilters, nullRef)}
        </div>
        <div className="filter-item filter-item-narrow">
          {FiltersHelper.getBrandsCountriesCard(filters, setFilters, nullRef)}
        </div>
        <div className="filter-item filter-item-regular">
          {FiltersHelper.getActivityStatusCard(filters, setFilters, nullRef)}
        </div>
        <div className="filter-item filter-item-wide">
          {FiltersHelper.getDemandSourcesCardForLookupPage(filters, setFilters, nullRef, demandSources)}
        </div>
        <div className="filter-item filter-item-regular">
          {FiltersHelper.getClinksStatusCard(filters, setFilters, nullRef)}
        </div>
        <div className="filter-item filter-item-narrow">
          {FiltersHelper.getUniqueSourcesCard(filters, setFilters, nullRef)}
        </div>
      </div>
    </div>
  );
};

export default LookupFiltersPanel;